import GenerateExcelService from "../provider/GenerateExcel/GenerateExcelService";
import { CHANGE_APP_PROPS } from "./ActionConstants";

export function actionGenerateExcelById(type, id, returnDownload) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Generando Excel ..."
			}
		});
		asyncGenerateExcelById(type, id)
			.then(response => {
				asyncDownloadFile(response.nombreArchivo)
					.then(resp => {
						dispatch({
							type: CHANGE_APP_PROPS,
							props: {
								loading: false,
								loadingText: "Cargando ..."
							}
						});
						// Toma la ruta del reporte generado.
						returnDownload(type, resp);
					})
					.catch(err => {
						dispatch({
							type: CHANGE_APP_PROPS,
							props: {
								loading: false,
								loadingText: "Cargando ..."
							}
						});
					});
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando ..."
					}
				});
			});
	};
}
export function actionGenerateExcel(type, date_from, date_to, returnDownload) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Generando Excel ..."
			}
		});
		asyncGenerateExcel(type, date_from, date_to)
			.then(response => {
				asyncDownloadFile(response.nombreArchivo)
					.then(resp => {
						dispatch({
							type: CHANGE_APP_PROPS,
							props: {
								loading: false,
								loadingText: "Cargando ..."
							}
						});
						// Toma la ruta del reporte generado.
						returnDownload(type, resp);
					})
					.catch(err => {
						dispatch({
							type: CHANGE_APP_PROPS,
							props: {
								loading: false,
								loadingText: "Cargando ..."
							}
						});
					});
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando ..."
					}
				});
			});
	};
}
async function asyncGenerateExcelById(type, id) {
	let response = await GenerateExcelService.generateExcelById(type, id);
	return response;
}
async function asyncGenerateExcel(type, date_from, date_to) {
	let response = await GenerateExcelService.generateExcel(
		type,
		date_from,
		date_to
	);
	return response;
}
async function asyncDownloadFile(fileName) {
	let response = await GenerateExcelService.downloadFile(fileName);
	return response;
}

export function actionGenerateExcelCompaniesNotRegistered(callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Generando Excel ..."
			}
		});
		asyncGenerateExcelCompaniesNotRegistered()
			.then(response => {
				asyncDownloadFile(response.nombreArchivo)
					.then(resp => {
						dispatch({
							type: CHANGE_APP_PROPS,
							props: {
								loading: false,
								loadingText: "Cargando ..."
							}
						});
						callback(resp);
					})
					.catch(err => {
						dispatch({
							type: CHANGE_APP_PROPS,
							props: {
								loading: false,
								loadingText: "Cargando ..."
							}
						});
					});
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando ..."
					}
				});
			});
	};
}

async function asyncGenerateExcelCompaniesNotRegistered() {
	return await GenerateExcelService.generateExcelCompaniesNotRegistered();
}

export function actionGenerateExcelAffiliatesPerCity(callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Generando Excel ..."
			}
		});
		asyncGenerateExcelAffiliatesPerCity()
			.then(response => {
				asyncDownloadFile(response.nombreArchivo)
					.then(resp => {
						dispatch({
							type: CHANGE_APP_PROPS,
							props: {
								loading: false,
								loadingText: "Cargando ..."
							}
						});
						callback(resp);
					})
					.catch(err => {
						dispatch({
							type: CHANGE_APP_PROPS,
							props: {
								loading: false,
								loadingText: "Cargando ..."
							}
						});
					});
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando ..."
					}
				});
			});
	};
}

async function asyncGenerateExcelAffiliatesPerCity() {
	return await GenerateExcelService.generateExcelAffiliatesPerCity();
}



// WEBPACK FOOTER //
// ./src/actions/GenerateExcelActions.js